import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const tokens = JSON.parse(localStorage.getItem('userTokens'));
    if (tokens && tokens && tokens.token && tokens.refreshToken) {
    //if (tokens &&  tokens.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokens.token}`
        }
      });
    }

    return next.handle(request);
  }
}
